module.exports = __webpack_public_path__ + "v4assets/fonts/journeys-teaser.d61de05d328587a0cf2e131abd824310.mp4";